import { Component, NgZone, OnDestroy, ViewChild } from '@angular/core';
import { AndroidPermissions } from '@ionic-native/android-permissions';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { TranslateService } from '@ngx-translate/core';
import { ModalController, Nav, Platform } from 'ionic-angular';
import * as moment from 'moment';
import 'moment/locale/id';
import { UserModel } from '../models/user/user';
import { ConfigurationPage } from '../pages/configuration/configuration';
import { DashBangkaPage } from '../pages/dash-bangka/dash-bangka';
import { DashBelitungPage } from '../pages/dash-belitung/dash-belitung';
import { DashDuriPage } from '../pages/dash-duri/dash-duri';
import { DashLampungPage } from '../pages/dash-lampung/dash-lampung';
import { DashLombokPage } from '../pages/dash-lombok/dash-lombok';
import { DashSuppaPage } from '../pages/dash-suppa/dash-suppa';
import { DashTelloPage } from '../pages/dash-tello/dash-tello';

// import { DashMedanPage } from '../pages/dash-medan/dash-medan';
import { DashNiasPage } from '../pages/dash-nias/dash-nias';
import { DashPontianakPage } from '../pages/dash-pontianak/dash-pontianak';
import { DashboardPage } from '../pages/dashboard/dashboard';
import { LoginPage } from '../pages/login/login';
import { AuthProvider } from '../providers/auth/auth';
import { ModalAboutPage } from './../pages/modal-about/modal-about';
import { UserPage } from './../pages/user/user';
import { AppVersionProvider } from './../providers/app-version/app-version';

@Component({
  templateUrl: 'app.html',
})
export class brightMPP implements OnDestroy {
  @ViewChild(Nav)
  nav: Nav;
  type: string;
  rootPage: any = LoginPage;
  language: string = 'id';

  menus: Array<{ _id: string; title: string; component: any; icon: string }>;
  submenus: Array<{ _id: string; title: string; component: any; icon: string }>;
  configs: Array<{ _id: string; title: string; component: any; icon: string }>;

  activePage: any;

  currentUser: UserModel;

  shownSubMenu = null;

  constructor(
    public platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    public translateSvc: TranslateService,
    public authPrvdr: AuthProvider,
    public androidPermissions: AndroidPermissions,
    public appVersionPrvdr: AppVersionProvider,
    private modalCtrl: ModalController,
    public zone: NgZone
  ) {
    let info = console.info.bind(console);
    info(
      '%cWe can talk, ... ' +
        "%cIf you're looking for disassembling my code, I'm affraid it will cost your time because it was minified and uglified. Need help for your project? We can talk. Just contact me at " +
        '%cyudhi@rmyndharis.com',
      "color: #63696d; font-family: 'PT Sans Narrow', sans-serif; font-weight: bold; font-size: x-large",
      "color: #63696d; font-family: 'PT Sans Narrow', sans-serif; font-size: x-large",
      "color:#444; font-family: 'PT Sans Narrow', sans-serif; font-size: x-large"
    );

    this.appVersionPrvdr.getType().then((type) => {
      this.type = type;
    });

    this.initTranslate();

    this.initializeApp();

    this.checkAuth();
  }

  initTranslate(): void {
    this.translateSvc.setDefaultLang('id');

    this.translateSvc.use('id');
    moment.locale('id');
    this.language = 'id';
  }

  initializeApp(): void {
    this.platform.ready().then(() => {
      // ANDROID PLATFORM
      if (this.platform.is('android')) {
        // STATUSBAR AND SPLASHSCREEN
        this.statusBar.styleDefault();
        this.splashScreen.hide();
      }
    });
  }

  checkAuth(): void {
    this.authPrvdr.checkLogin();
    this.authPrvdr.authUser.subscribe((jwt) => {
      if (jwt) {
        this.authPrvdr.userData.subscribe(
          (res) => {
            if (res !== null) {
              this.currentUser = res;
              this.buildMenu(res.role.menus);
            } else {
              this.rootPage = LoginPage;
            }
          },
          (error) => {
            this.rootPage = LoginPage;
          }
        );
      } else {
        this.rootPage = LoginPage;
      }
    });
  }

  buildMenu(menu: any): void {
    let defMenus = [
      {
        _id: '5b41b21fbe859911d832f87e',
        title: 'DASHBOARD',
        component: DashboardPage,
        icon: 'md-stats',
      },
    ];

    let defSubMenus = [
      {
        _id: '5fc0ba831d3f7946d022ad25',
        title: 'GUNUNG SITOLI - NIAS',
        component: DashNiasPage,
        icon: 'md-speedometer',
      },
      {
        _id: '5fc320086311e138145332b3',
        title: 'BALAI PUNGUT - DURI',
        component: DashDuriPage,
        icon: 'md-speedometer',
      },
      {
        _id: '5fc608736311e138145332bd',
        title: 'AIR ANYIR - BANGKA',
        component: DashBangkaPage,
        icon: 'md-speedometer',
      },
      {
        _id: '61b385376b620000a2004a93',
        title: 'SUGE - BELITUNG',
        component: DashBelitungPage,
        icon: 'md-speedometer',
      },
      {
        _id: '61b385446b620000a2004a94',
        title: 'TARAHAN - LAMPUNG',
        component: DashLampungPage,
        icon: 'md-speedometer',
      },
      {
        _id: '61b3854a6b620000a2004a95',
        title: 'PARIT BARU - PONTIANAK',
        component: DashPontianakPage,
        icon: 'md-speedometer',
      },
      {
        _id: '61b385566b620000a2004a96',
        title: 'JERANJANG - LOMBOK',
        component: DashLombokPage,
        icon: 'md-speedometer',
      },

      {
        _id: '6621d8dda441fd3b59099479',
        title: 'SUPPA - MAKASSAR',
        component: DashSuppaPage,
        icon: 'md-speedometer',
      },

      {
        _id: '6621d8f9a441fd3b5909947a',
        title: 'TELLO - MAKASSAR',
        component: DashTelloPage,
        icon: 'md-speedometer',
      },
    ];

    let defConfigs = [
      {
        _id: '5b5496e62262a235f8a01270',
        title: 'CONFIGURATION',
        component: ConfigurationPage,
        icon: 'md-cog',
      },
    ];

    let userMenu = [];
    let userConfig = [];

    menu.forEach((allowed) => {
      defMenus.forEach((def) => {
        if (allowed === def._id) {
          userMenu.push(def);
        }
      });

      defConfigs.forEach((con) => {
        if (allowed == con._id) {
          userConfig.push(con);
        }
      });
    });

    this.submenus = defSubMenus;

    this.menus = userMenu;
    this.configs = userConfig;
    this.openPage(this.menus[0]);
  }

  onShowAbout() {
    const modal = this.modalCtrl.create(ModalAboutPage);
    modal.present();
  }

  onShowProfile(): void {
    this.openPage({ component: UserPage });
  }

  openPage(page): void {
    if (this.activePage && page._id === this.activePage._id) return;
    this.nav.setRoot(page.component);
    this.activePage = page;
  }

  checkActive(page) {
    return page === this.activePage;
  }

  toggleSubMenu(group) {
    if (this.isSubMenuToggled(group)) {
      this.shownSubMenu = null;
    } else {
      this.shownSubMenu = group;
    }
  }

  isSubMenuToggled(group) {
    return this.shownSubMenu === group;
  }

  onChangeLanguage(language): void {
    this.translateSvc.use(language);
    moment.locale(language);
  }

  doLogout(): void {
    this.authPrvdr.logout();
    this.rootPage = LoginPage;
    this.openPage({ component: LoginPage });
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts